import './style.scss';
import mountRedplusAppContainer from 'Container/App';

mountRedplusAppContainer();
